export const CREATE_AUTOMATION = 'create_automation';
export const UPDATE_AUTOMATION = 'update_automation';
export const UPDATE_AUTOMATION_VALUE = 'update_automation_value';
export const NO_PERMISSION = 'no_permission';
export const VIEW_ALL_DOMAINS = 'view_all_domains';
export const CREATE_PARTNER = 'create_partner';
export const CREATE_DOMAIN = 'create_domain';
export const CREATE_INDUSTRY = 'create_industry';
export const CREATE_MASTER_PARTNER = 'create_master_partner';